import * as R from 'ramda'

export default (properties) => {
	let res = R.map(property => {
		return property.downPayment || 0
	})(properties)
	res.total = R.pipe(R.values, R.reduce((acc, next) => acc + next, 0))(res)
	return res
}



// WEBPACK FOOTER //
// ./src/helpers/kpi/investment.js